import { useUiStore } from '../stores/ui';

export const AjaxLoader = {
  data() {
    return {
      activeLoading: false,
      loadingCount: 0
    };
  },

  methods: {
    clearLoader() {
      if (this.loadingCount > 0) {
        this.loadingCount--;
      }

      if (this.loadingCount === 0) {
        this.activeLoading = false;
        // Clear global loading state
        const uiStore = useUiStore();

        uiStore.setLoadingState(false);
      }
    },

    startLoading() {
      this.loadingCount++;
      this.activeLoading = true;
      // Set global loading state
      const uiStore = useUiStore();

      uiStore.setLoadingState(true);
    }
  }
};
